"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnceEffect = void 0;
var react_1 = __importDefault(require("react"));
/**
 * `useLayoutEffect`, but never runs twice, even in React 18 StrictMode.
 */
exports.useOnceEffect = react_1.default.useInsertionEffect || react_1.default.useLayoutEffect;
